import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as forgotPasscodeVerify from '../reducers/forgot-password-verify.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE GOV ID AND PASSPORT NUMBER SUB STATE
export const getForgotPasscodeVerifyState = createSelector(getAuthState, state => state[forgotPasscodeVerify.forgotPasswordFeatureKey]);

export const getForgotPasscodeVerifyIsLoading = createSelector(
  getForgotPasscodeVerifyState,
  forgotPasscodeVerify.getForgotPasswordsVerifyIsLoading
);

export const getForgotPasscodeVerifyRequest = createSelector(
  getForgotPasscodeVerifyState,
  forgotPasscodeVerify.getForgotPasswordsVerifyRequest
);

export const getForgotPasscodeVerifyResponse = createSelector(
  getForgotPasscodeVerifyState,
  forgotPasscodeVerify.getForgotPasswordsVerifyResponse
);

export const getForgotPasscodeVerifyFailure = createSelector(
  getForgotPasscodeVerifyState,
  forgotPasscodeVerify.getForgotPasswordsVerifyFailure
);
